export default "__VITE_ASSET__5e6ed8de__"